"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollChoices = exports.PostViewableEnum = exports.PostType = void 0;
var PostType;
(function (PostType) {
    PostType[PostType["FEEDPOST"] = 0] = "FEEDPOST";
    PostType[PostType["SHORT_MESSAGE"] = 1] = "SHORT_MESSAGE";
    PostType[PostType["POLL"] = 2] = "POLL";
})(PostType = exports.PostType || (exports.PostType = {}));
var PostViewableEnum;
(function (PostViewableEnum) {
    PostViewableEnum[PostViewableEnum["MEMBER"] = 0] = "MEMBER";
    PostViewableEnum[PostViewableEnum["PARENTS"] = 1] = "PARENTS";
})(PostViewableEnum = exports.PostViewableEnum || (exports.PostViewableEnum = {}));
var PollChoices;
(function (PollChoices) {
    PollChoices[PollChoices["SINGLE_CHOICE"] = 0] = "SINGLE_CHOICE";
    PollChoices[PollChoices["MULTIPLE_CHOICE"] = 1] = "MULTIPLE_CHOICE";
})(PollChoices = exports.PollChoices || (exports.PollChoices = {}));
//# sourceMappingURL=post.js.map